import { Component, OnInit, ViewChild } from '@angular/core';
import { FiaService } from 'src/app/services/fia.service';
import { MediaService } from 'src/app/services/media.service';
import { SettingsService } from 'src/app/services/settings.service';
import { UserService } from 'src/app/services/user.service';
import { LookupMediaTypes } from 'src/app/shared/models/general/lookup-media-types';
import { Media } from 'src/app/shared/models/general/media';
import { MediaInfo } from 'src/app/shared/models/general/media-info';
import { FiaApplication } from 'src/app/shared/models/users/fia-application';
import { UserFullDetails } from 'src/app/shared/models/users/user-full-details';
import { UserProfile } from 'src/app/shared/models/users/user-profile';
import { UserRole } from 'src/app/shared/models/users/user-role';
import { Users } from 'src/app/shared/models/users/users';
import { getEmailRegExpression } from 'src/app/utils/utils.common';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent implements OnInit {
  @ViewChild('avatarModal', { static: true }) avatarModal: any;
  @ViewChild('newSupportingDocsModal', { static: true }) newSupportingDocsModal: any;
  @ViewChild('confirmDeleteModal', { static: true }) confirmDeleteModal: any;

  //File selector
  @ViewChild('file') file;

  busy: boolean = false;
  showError: boolean = false;
  errorMsg: string = 'Oops! Looks like something went wrong, please contact support if this issue persists';

  modalBusy: boolean = false;
  showModalError: boolean = false;
  errorModalMsg: string = 'Oops! Looks like something went wrong, please contact support if this issue persists';

  mediaTypes: LookupMediaTypes[] = [];

  user: Users = new Users();
  userDocuments: Media[] = [];
  userNewDocuments: MediaInfo[] = [];
  userDocumentsToDelete: number[] = [];
  userProfile: UserProfile = new UserProfile();
  userFiaApplications: FiaApplication[] = [];
  userRoles: UserRole[];

  regexForEmail = getEmailRegExpression();

  avatarImageIds = [
    { id: 1 },
    { id: 2 },
    { id: 3 },
    { id: 4 },
    { id: 5 },
    { id: 6 },
    { id: 7 },
    { id: 8 },
    { id: 9 },
    { id: 10 },
    { id: 11 },
    { id: 12 },
    { id: 13 },
    { id: 14 },
    { id: 15 },
    { id: 16 },
    { id: 17 },
    { id: 18 },
    { id: 19 },
    { id: 20 },
  ];

  currentSection: string = 'Profile';

  constructor(
    public settingsService: SettingsService,
    public usersService: UserService,
    public fiaService: FiaService,
    public mediaService: MediaService
  ) {
    this.busy = true;
    this.settingsService.ValidateGlobalVars().then(() => {
      this.user = <Users>JSON.parse(JSON.stringify(this.settingsService.user));
      this.userProfile = <UserProfile>JSON.parse(JSON.stringify(this.settingsService.userProfile));
      this.userFiaApplications = <FiaApplication[]>JSON.parse(JSON.stringify(this.settingsService.userFiaApplications));
      this.userRoles = <UserRole[]>JSON.parse(JSON.stringify(this.settingsService.user.userRoles));
      this.busy = false;
    });
  }

  ngOnInit(): void {}
  saveClicked() {
    this.busy = true;
    var userFullDetails = new UserFullDetails();
    userFullDetails.user = this.user;
    userFullDetails.profile = this.userProfile;
    this.usersService.UserProfileUpdate(userFullDetails).subscribe(
      () => {
        this.settingsService.GetUserDetails().then(() => {
          this.userProfile = <UserProfile>JSON.parse(JSON.stringify(this.settingsService.userProfile));
          this.user = <Users>JSON.parse(JSON.stringify(this.settingsService.user));
          this.avatarModal.hide();
          this.showError = false;
          this.busy = false;
        });
      },
      (error) => {
        this.showError = true;
        this.busy = false;
        this.errorMsg = error.error.ErrorDetail;
        console.log(error);
      }
    );
  }

  toggleSettingsSection(section: string) {
    this.currentSection = section;
    if (this.currentSection == 'Profile') {
    } else if (this.currentSection == 'FIA') {
      this.GetUserMedia();
    } else if (this.currentSection == 'Security') {
    } else if (this.currentSection == 'Activity') {
    } else if (this.currentSection == 'Privacy') {
    } else if (this.currentSection == 'Payment') {
    }
  }

  avatarSelected(avatarId: number) {
    this.userProfile.avatarId = avatarId;
  }

  GetUserMedia() {
    this.busy = true;
    this.mediaService.GetFiaSupportingDocuments(this.userProfile.userId, this.settingsService.fiaSupportingMediaTypes[1].Id).subscribe(
      (response) => {
        this.userDocuments = response;
        this.busy = false;
      },
      (error) => {
        this.showError = true;
        this.errorMsg = error.error.ErrorDetail;
        this.busy = false;
      }
    );
  }

  //===============File handling===============
  DownloadFile(id: number) {
    this.busy = true;
    this.mediaService.DownloadMedia(id).subscribe(
      (response) => {
        this.mediaService.Download(response);
        this.busy = false;
      },
      (error) => {
        this.showError = true;
        this.errorMsg = error.error.ErrorDetail;
        this.busy = false;
      }
    );
  }

  onFileChange(fileInput: any) {
    this.userNewDocuments = [];
    var totalSize: number = 0;
    var maxSize: number = 5000000;
    const files: { [key: string]: File } = this.file.nativeElement.files;
    for (let key in files) {
      if (!isNaN(parseInt(key))) {
        var reader = new FileReader();
        reader.onload = (event: any) => {
          if (totalSize <= maxSize && files[key].size <= maxSize) {
            var file: MediaInfo = new MediaInfo();
            file.name = files[key].name;
            file.fileName = files[key].name;
            file.mimeType = files[key].type;
            file.fileType = '';
            file.tag = 'FiaApplicationSharedSupportingDocuments';
            file.data = event.target.result;
            file.data = file.data.replace('data:' + files[key].type + ';base64,', '');
            file.entityId = this.userProfile.userId;
            file.entityType = this.settingsService.userEntity.description; // Users
            totalSize += files[key].size;
            this.userNewDocuments.push(file);
          } else {
            console.log('Max upload size reached');
            this.showError = true;
            this.errorMsg = 'Max file upload size reached';
          }
        };

        reader.readAsDataURL(files[key]);
      }
    }
    this.newSupportingDocsModal.show();
  }

  removeFile(fileName: string) {
    this.busy = true;
    this.userNewDocuments.forEach((value, index) => {
      if (value.fileName == fileName) {
        this.userNewDocuments.splice(index, 1);
      }
    });
    this.busy = false;
  }

  confirmDelete(id: number) {
    this.userDocumentsToDelete.push(id);
    this.confirmDeleteModal.show();
  }

  cancelDelete() {
    this.userDocumentsToDelete = [];
    this.confirmDeleteModal.hide();
  }

  confirmDeleteModalYesClicked() {
    this.busy = true;
    this.DeleteUserMedia().then(
      () => {
        this.confirmDeleteModal.hide();
        this.GetUserMedia();
      },
      (error) => {
        this.showError = true;
        this.busy = false;
        this.confirmDeleteModal.hide();
      }
    );
  }

  public DeleteUserMedia() {
    if (!this.userDocumentsToDelete || this.userDocumentsToDelete.length == 0) {
      return new Promise((resolve) => {
        resolve(true);
      });
    }

    return Promise.all(this.userDocumentsToDelete.map(async (v) => this.mediaService.DeleteMediaAsync(v))).then(
      () => {},
      (rejected) => {}
    );
  }

  missingDocumentTypes(): boolean {
    return this.userNewDocuments.some((doc) => !doc.fileType?.trim());
  }

  newSupportingDocumentsModalSaveClicked() {
    this.showModalError = false;
    this.errorModalMsg = '';
    if (this.missingDocumentTypes()) {
      this.showModalError = true;
      this.errorModalMsg = 'Please select a type for all documents.';
      return;
    }

    this.modalBusy = true;
    this.UploadUserMedia().then(
      () => {
        //Upload new docs
        this.modalBusy = false;
        this.newSupportingDocsModal.hide();
        this.GetUserMedia();
      },
      (error) => {
        this.modalBusy = false;
        this.showModalError = true;
        this.errorModalMsg = error.error.ErrorDetail;
      }
    );
  }

  public UploadUserMedia() {
    if (!this.userNewDocuments || this.userNewDocuments.length == 0) {
      return new Promise((resolve) => {
        resolve(true);
      });
    }

    return Promise.all(this.userNewDocuments.map(async (v) => this.mediaService.UploadMediaAsync(v))).then(
      () => {},
      (rejected) => {}
    );
  }
}
